import axios from 'axios';
import {download, loginreq, req} from './axiosFun';

// 登录接口
export const login = (params) => {
    return loginreq("post", "/api/login", params)
};
// 退出接口
export const loginout = () => {
    return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data)
};

// 菜单管理-根据菜单获取数据
//export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };

// 菜单管理-删除菜单
//export const ModuleDelete = (params) => { return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };


/**
 * 题库管理
 */
// 获取题库列表
export const questionBankList = (params) => {
    return req("post", "/bank/list", params)
};
// 新规,编辑
export const questionBankSave = (params) => {
    return req("post", "/bank/save", params)
};
// 删除
export const questionBankDelete = (params) => {
    return req("delete", "/bank/delete/" + params)
};


/**
 * 题目管理
 */
// 获取题目列表(题目详情画面用)
export const questionListByPage = (params) => {
    return req("post", "/question/page/list", params)
};
// 获取题目列表
export const questionList = (params) => {
    return req("post", "/question/list", params)
};
// 新规,编辑
export const questionSave = (params) => {
    return req("post", "/question/save", params)
};
// 删除题目（物理删除）
export const questionDelete = (params) => {
    return req("delete", "/question/delete/" + params)
};
// 获取题目列表,以维度
export const questionListByMethod = (params) => {
    return req("post", "/question/mlist", params)
};


/**
 * 维度管理
 */
// 维度列表
export const statisticMethodList = (params) => {
    return req("post", "/method/list", params)
};
// 新规,编辑维度
export const statisticMethodSave = (params) => {
    return req("post", "/method/save", params)
};
// 删除维度（物理删除）
export const statisticMethodDelete = (params) => {
    return req("delete", "/method/delete/" + params)
};


/**
 * 维度详情管理
 */
// 维度详情列表
export const statisticMethodDetailList = (params) => {
    return req("post", "/method/detail/list", params)
};
// 新规,编辑维度详情
export const statisticMethodDetailSave = (params) => {
    return req("post", "/method/detail/save", params)
};
// 新规,编辑维度详情关系数据
export const statisticMethodDetailRelationSave = (params) => {
    return req("post", "/method/detail/save-relation", params)
};
// 删除维度详情（物理删除）
export const statisticMethodDetailDelete = (params) => {
    return req("delete", "/method/detail/delete/" + params)
};

/**
 * 用户管理
 */
// 获取微信用户一览
export const wxUserList = (params) => {
    return req("post", "/user/list", params)
};
// 获取微信用户保存
export const wxUserSave = (params) => {
    return req("post", "/user/save", params)
};
// 禁用微信用户
export const wxUserStatus = (params) => {
    return req("post", "/user/status", params)
};
// 用户得分详情导出
export const wxUserExport = (params, filename) => {
    return download("/user/export",
        params,
        filename)
};



// WEBPACK FOOTER //
// ./src/api/api.js